module.exports = __webpack_public_path__ + "static/img/content_bg.fc484623.webp";